import { privateInstance } from "../configs";

export const storeApi = {
  async patchStore(id, store) {
    const res = await privateInstance.patch(`main/api/store/ru/${id}/`, store);
    return res.data;
  }
};
